import { ErrorType } from "@/shared/types"
import { createSlice } from "@reduxjs/toolkit"
import { deleteSavedDocumentThunk, fetchSavedDocuments } from "./aviabooking-saved-documents-thunk"
import { SavedDocumentsState } from "./types"

const initialState: SavedDocumentsState = {
    savedDocuments: [],
    savedDocumentsError: null,
    isSavedDocumentsLoading: false,
    isSavedDocumentsFirstLoad: true
}

const aviabookingSavedDocumentsSlice = createSlice({
    name: 'aviabookingSavedDocuments',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchSavedDocuments.pending, (state) => {
            state.isSavedDocumentsLoading = true
        })
        builder.addCase(fetchSavedDocuments.fulfilled, (state, action) => {
            state.isSavedDocumentsLoading = false
            state.savedDocuments = action.payload
            state.savedDocumentsError = null
            state.isSavedDocumentsFirstLoad = false
        })
        builder.addCase(fetchSavedDocuments.rejected, (state, action) => {
            state.isSavedDocumentsLoading = false
            state.savedDocumentsError = action.payload as ErrorType
            state.isSavedDocumentsFirstLoad = false
        })
        builder.addCase(deleteSavedDocumentThunk.fulfilled, (state, action) => {
            state.savedDocuments = state.savedDocuments.filter((d) => d.id !== action.payload)
        })
    }
})

export default aviabookingSavedDocumentsSlice.reducer
